import React from 'react'
import Settings from 'components/Owner/Tools/Settings'
import CircleTick from 'assets/svgs/circle-icon.svg'

const ConnectedView = ({ handleDisconnect }) => {
  return (
    <div className="flex items-center justify-between gap-2 mt-auto w-full">
      <Settings handleDisconnect={handleDisconnect} />
      <span className="text-base text-primary-text flex  items-center gap-2 ">
        <img src={CircleTick} alt="tick" /> Connected
      </span>
    </div>
  )
}

export default ConnectedView
